import React, {useEffect, useState} from "react"
import {Alert, Button, Drawer, Form, Input, Select, Switch} from "antd"
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"
import {EncheresAPI, poserHint} from "./api"

// Ce que le fidèle règle une fois pour toutes.
//
// Trois choses, et rien de plus :
//
//   · sa TRIBU — sans elle, un Cohen ne peut pas enchérir sur la montée qui lui
//     est réservée ; la feuille de mise le lui dit, encore faut-il qu'il ait un
//     endroit où la renseigner ;
//   · son NOM D'APPEL, celui que le gabbaï annonce à la Torah ;
//   · les E-MAILS — parce qu'une vente qui écrit trois fois en une soirée à
//     quelqu'un qui n'en veut pas se fait couper par son fournisseur de
//     messagerie, et la communauté entière cesse d'être prévenue.
//
// La déconnexion est là parce que les enchères se suivent souvent sur le
// téléphone d'un voisin, à la sortie de l'office.
export default function ProfilSheet({ouvert, identifier, onFerme, onEnregistre, onDeconnecte}) {
    const [form] = Form.useForm()
    const [chargement, setChargement] = useState(false)
    const [envoi, setEnvoi] = useState(false)
    const [erreur, setErreur] = useState(null)
    const [moi, setMoi] = useState(null)

    useEffect(() => {
        if (!ouvert) return
        let vivant = true
        setErreur(null)
        setChargement(true)
        EncheresAPI.moi(identifier)
            .then((res) => {
                if (!vivant) return
                const contact = (res && res.contact) || {}
                const notif = (res && res.notif) || {}
                setMoi(contact)
                form.setFieldsValue({
                    nomHebreu: contact.nomHebreu || "",
                    tribu: contact.tribu || null,
                    email: notif.email !== false,
                })
            })
            .catch(() => vivant && setErreur(t`Vos réglages n'ont pas pu être chargés.`))
            .finally(() => vivant && setChargement(false))
        return () => { vivant = false }
    }, [ouvert, identifier])

    const enregistrer = async (valeurs) => {
        setEnvoi(true)
        setErreur(null)
        try {
            const res = await EncheresAPI.profil(identifier, {
                nomHebreu: valeurs.nomHebreu || "",
                tribu: valeurs.tribu || "",
                notif: {email: valeurs.email !== false},
            })
            if (!res || res.success === false) {
                setErreur(t`Vos réglages n'ont pas pu être enregistrés. Réessayez.`)
                setEnvoi(false)
                return
            }
            if (onEnregistre) onEnregistre()
            if (onFerme) onFerme()
        } catch (_) {
            setErreur(t`Vos réglages n'ont pas pu être enregistrés. Réessayez.`)
        } finally {
            setEnvoi(false)
        }
    }

    const deconnecter = async () => {
        try {
            await EncheresAPI.fermer()
        } catch (_) { /* la session expirera d'elle-même */ }
        poserHint(false)
        if (onDeconnecte) onDeconnecte()
        if (onFerme) onFerme()
    }

    const nom = moi ? [moi.prenom, moi.nom].filter(Boolean).join(" ") : ""

    return (
        <Drawer
            open={ouvert}
            placement="bottom"
            height="auto"
            onClose={onFerme}
            title={nom || t`Mes réglages`}
            className="ench-sheet"
        >
            {erreur && <Alert type="warning" showIcon message={erreur} style={{marginBottom: 14}}/>}

            {moi && moi.email && <div className="ench-sheet-actuel">{moi.email}</div>}

            <Form form={form} layout="vertical" requiredMark={false} onFinish={enregistrer} disabled={chargement}>
                <Form.Item
                    label={t`Cohen, Lévi ou Israël`}
                    name="tribu"
                    extra={t`Certaines montées sont réservées : sans cette information, elles vous sont refusées.`}
                >
                    <Select
                        allowClear
                        placeholder={t`Ne sais pas`}
                        options={[
                            {value: "COHEN", label: t`Cohen`},
                            {value: "LEVI", label: t`Lévi`},
                            {value: "ISRAEL", label: t`Israël`},
                        ]}
                    />
                </Form.Item>

                <Form.Item
                    label={t`Nom d'appel à la Torah`}
                    name="nomHebreu"
                    extra={t`C'est ce nom que le gabbaï annoncera.`}
                >
                    <Input placeholder={t`Ex. : Avraham ben Yits'hak`}/>
                </Form.Item>

                <div className="ench-sheet-switch">
                    <Form.Item name="email" valuePropName="checked" noStyle>
                        <Switch/>
                    </Form.Item>
                    <span>
                        <Trans>Me prévenir par e-mail quand je suis dépassé ou quand j'emporte un lot.</Trans>
                    </span>
                </div>

                <Button type="primary" size="large" block htmlType="submit" loading={envoi}>
                    <Trans>Enregistrer</Trans>
                </Button>
            </Form>

            <button type="button" className="ench-lien ench-lien-sortie" onClick={deconnecter}>
                <Trans>Ce n'est pas vous ? Se déconnecter</Trans>
            </button>
        </Drawer>
    )
}
